import React, { useState, useEffect } from "react";
import "./assets/css/style-cloud.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../Style/typo.css";
import NavButton from "../homepage/header-banner/TopNavButton";
import Footer from "../homepage/footer/Footer";
import "./assets/css/main-demo.css";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import mail from "./assets/image/mail.png";
import approval from "./assets/image/approval.png";
import report from "./assets/image/report.png";
import clouddisk from "./assets/image/clouddisk.png";
import comanage from "./assets/image/comanage.png";
import project from "./assets/image/project.png";
import calendar from "./assets/image/calendar.png";
import todo from "./assets/image/todo.png";
import board from "./assets/image/board.png";
import contact from "./assets/image/contact.png";
import hr from "./assets/image/hr.png";
import note from "./assets/image/note.png";
import whisper from "./assets/image/whisper.png";
import expense from "./assets/image/expense.png";
import asset from "./assets/image/asset.png";
import archive from "./assets/image/archive.png";
import circular from "./assets/image/circular.png";
import resource from "./assets/image/resource.png";
import workdiary from "./assets/image/diary.png";
import organization from "./assets/image/organization.png";

import remote from "./assets/image/remote-control.png";

import timecard from "./assets/image/timecard.png";
import vacation from "./assets/image/vacation.png";
import talk from "./assets/image/talk.png";
import memo from "./assets/image/memo.png";
import conference from "./assets/image/video-conference.png";

import Vector1 from "./assets/image/Vector-1.png";
import Vector2 from "./assets/image/Vector-2.png";
import Vector3 from "./assets/image/Vector-3.png";
import { BsTranslate } from "react-icons/bs";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';


const servicesData = {
    gw: { name: "Groupware", perUser: 10, unit: "GB", cost: 3500, minUsers: 3 },
    mail: { name: "Mail", perUser: 5, unit: "GB", cost: 1000, minUsers: 5 },
    hr: { name: "HR", fixed: 5, unit: "GB", cost: 1000, minUsers: 5 },
    mess: { name: "Messenger", perUser: 1, unit: "GB", cost: 1000, minUsers: 5 },
};

const getCostFromOption = (value) => {
    switch (value) {
        case "50":
            return 10000;
        case "500":
            return 70000;
        case "1000":
            return 100000;
        default:
            return 0;
    }
};



function Pricing() {
    useEffect(() => {
        console.log("hi")
        window.scrollTo(0, 0);
    }, []); // chạy 1 lần khi component được mount
    const [isOpen, setIsOpen] = useState(false); // modal hidden by default

    const toggleModal = () => {
        setIsOpen(prev => !prev);
    };
    // const [activeTab, setActiveTab] = useState("tab1");
    // const [paymentMethod, setPaymentMethod] = useState("1");

    // const handleTabClick = (tabName) => {
    //     setActiveTab(tabName);
    // };

    const numberWithCommas = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    const [show, setShow] = useState(false); // Trạng thái ẩn/hiện

    const toggleDropdown = () => {
        setShow(prev => !prev);
    };
    const [currentService, setCurrentService] = useState("gw");
    const [userCount, setUserCount] = useState(1);
    const [cloudDiskBaseUsers] = useState(10);
    const [selectedStorage, setSelectedStorage] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("1");

    const serviceData = servicesData[currentService];

    useEffect(() => {
        if (currentService === "cloud") {
            setUserCount(cloudDiskBaseUsers);
        } else {
            setUserCount(1);
        }
    }, [currentService]);

    const calculateBaseStorage = () => {
        if (currentService === "hr") {
            return serviceData.fixed;
        } else if (currentService === "cloud") {
            const adjusted = Math.ceil(userCount / 10) * 10;
            return (adjusted / 10) * serviceData.per10Users;
        } else {
            return userCount * (serviceData.perUser || 0);
        }
    };

    const baseStorage = calculateBaseStorage();
    const additionalStorage = parseInt(selectedStorage) || 0;
    const cost = getCostFromOption(selectedStorage);
    const totalStorage = baseStorage + additionalStorage;
    const baseCost = userCount * serviceData.cost;
    const finalTotal = baseCost + cost;

    const discountRate = paymentMethod === "6" ? 0.1 : paymentMethod === "12" ? 0.15 : 0;
    const months = parseInt(paymentMethod);
    const paymentAmount = finalTotal * months;
    const discountPrice = paymentAmount * discountRate;
    const needPay = paymentAmount - discountPrice;

    const paymentName = paymentMethod === "6" ? "6개월 선납" : paymentMethod === "12" ? "12개월 선납" : "월 납부";

    const gbPer = selectedStorage === "1000" ? 1 : parseInt(selectedStorage) || 0;
    const unitLabelPer = selectedStorage === "1000" ? "TB" : "GB";

    return (
        <div>
            <NavButton
                lang="ko"
                option={{
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061FF" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />

            <div class="container-fluid pricing-font">
                <div class="pricing-functional-wrapper section-padding">
                    <div class="price-title " >
                        <span class="typo-32-mb">그룹웨어 비용 안내</span>
                        <span class="typo-21">
                            업무 상황에 따라 유연하게 적용 가능한 <br className="title-br"></br> 다양한  솔루션을 제공합니다.  <br></br>선납시 최대 15% 할인 제공!
                        </span>
                    </div>
                    
                    
                    <div class="pricing-container">
                        <div class="pricing-container-card">
                            <div class="custom-card">
                                <div className={`custom-card-1 ${show ? 'active' : ''}`}>
                                    <div class="custom-title custom-padding">
                                        <span class="typo-21 typo-medium">메일</span>
                                        <div class="custom-detail">
                                            <span class="typo-16">최소 5유저부터 시작</span>
                                        </div>
                                    </div>
                                    
                                    <div class="custom-pirce custom-padding">
                                        <span class="typo-32 ">1,000원 </span>
                                        <span class="typo-16">/ 월 유저당 5GB</span>
                                    </div>
                                    <a class="custom-button custom-padding" href="https://hanbiro.com/#/mail-free-trial">
                                        <button class="typo-16">자세히 알아보기</button>
                                    </a>
                                    <div class="custom-radio ">
                                        <div class="custom-radio-1">
                                            <p className="custom-radio-txt item-padding">
                                                <img src={mail} />
                                                <span class="typo-16 pri-typo-14">메일</span>
                                            </p>
                                            <p className="custom-radio-txt item-padding">
                                                <img src={calendar} />
                                                <span class="typo-16 pri-typo-14">일정</span>
                                            </p>
                                            <p className="custom-radio-txt item-padding">
                                                <img src={workdiary} />
                                                <span class="typo-16 pri-typo-14">노트</span>
                                            </p>
                                            <p className="custom-radio-txt item-padding">
                                                <img src={clouddisk} />
                                                <span class="typo-16 pri-typo-14">클라우드디스크</span>
                                            </p>
                                        </div>
                                        <div class="custom-radio-1">
                                            <p className="custom-radio-txt item-padding">
                                                <img src={contact} />
                                                <span class="typo-16 pri-typo-14">주소록</span>
                                            </p>
                                            <p className="custom-radio-txt item-padding">
                                                <img src={board} />
                                                <span class="typo-16 pri-typo-14">게시판</span>
                                            </p>
                                            <p className="custom-radio-txt item-padding">
                                                <img src={whisper} />
                                                <span class="typo-16 pri-typo-14">쪽지</span>
                                            </p>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="pricing-container-card">
                            <div class="custom-card">
                                <div className={`custom-card-1 ${show ? 'active' : ''}`}>
                                    <div class="custom-title custom-padding">
                                        <span class="typo-21 typo-medium">HR</span>
                                        <div class="custom-detail">
                                            <span class="typo-16">최소 5유저부터 시작</span>
                                        </div>
                                    </div>
                                    
                                    <div class="custom-pirce custom-padding">
                                        <span class="typo-32 ">1,000원 </span>
                                        <span class="typo-16">/ 월 회사당 5GB</span>
                                    </div>
                                    <a class="custom-button custom-padding" href="https://hanbiro.com/#/hr-free-trial">
                                        <button class="typo-16">자세히 알아보기</button>
                                    </a>
                                    <div class="custom-radio">
                                        <div class="custom-radio-1">
                                            <p className="custom-radio-txt item-padding">
                                                <img src={timecard} />
                                                <span class="typo-16 pri-typo-14">근태</span>
                                            </p>
                                            <p className="custom-radio-txt item-padding">
                                                <img src={board} />
                                                <span class="typo-16 pri-typo-14">게시판</span>
                                            </p>

                                        </div>
                                        <div class="custom-radio-1">
                                            <p className="custom-radio-txt item-padding">
                                                <img src={vacation} />
                                                <span class="typo-16 pri-typo-14">휴가</span>
                                            </p>
                                            <p className="custom-radio-txt item-padding">
                                                <img src={whisper} />
                                                <span class="typo-16 pri-typo-14">쪽지</span>
                                            </p>


                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="pricing-container-card" id="col-e">
                            <div class="custom-card ">
                               
                                <div className={`custom-card-1 ${show ? 'active' : ''}`}>
                                    <div class="custom-title custom-padding">
                                        <span class="typo-21 typo-medium">그룹웨어</span>
                                         <div class="custom-detail">
                                            <span class="typo-16">최소 3유저부터 시작</span>
                                        </div>
                                    </div>
                                    <div class="custom-pirce custom-padding">
                                        <span class="typo-32 ">3,500원 </span>
                                        <span class="typo-16">/월 유저당 10GB</span>
                                    </div>
                                    <a class="custom-button custom-padding" href="https://hanbiro.com/#/groupware-free-trial">
                                        <button class="typo-16">자세히 알아보기</button>
                                    </a>
                                    <div class="custom-radio">
                                        <div class="custom-radio-1">
                                            <p className="custom-radio-txt item-padding">
                                                <img src={mail} />
                                                <span class="typo-16 pri-typo-14">메일</span>
                                            </p>
                                            <p className="custom-radio-txt item-padding">
                                                <img src={timecard} />
                                                <span class="typo-16 pri-typo-14">근태</span>
                                            </p>
                                            <p className="custom-radio-txt item-padding">
                                                <img src={talk} />
                                                <span class="typo-16 pri-typo-14">메신저</span>
                                            </p>

                                            <p className="custom-radio-txt item-padding">
                                                <img src={comanage} />
                                                <span class="typo-16 pri-typo-14">협업관리</span>
                                            </p>

                                            {/* Show more  */}
                                            {show && (
                                                <div>
                                                    <p className="custom-radio-txt item-padding">
                                                        <img src={clouddisk} />
                                                        <span class="typo-16 pri-typo-14">클라우드디스크</span>
                                                    </p>
                                                    <p className="custom-radio-txt item-padding">
                                                        <img src={calendar} />
                                                        <span class="typo-16 pri-typo-14">일정</span>
                                                    </p>
                                                    <p className="custom-radio-txt item-padding">
                                                        <img src={contact} />
                                                        <span class="typo-16 pri-typo-14">주소록</span>
                                                    </p>
                                                    <p className="custom-radio-txt item-padding">
                                                        <img src={report} />
                                                        <span class="typo-16 pri-typo-14">업무</span>
                                                    </p>

                                                    <p className="custom-radio-txt item-padding">
                                                        <img src={whisper} />
                                                        <span class="typo-16 pri-typo-14">쪽지</span>
                                                    </p>
                                                </div>
                                            )}

                                        </div>
                                        <div class="custom-radio-1">
                                            <p className="custom-radio-txt item-padding">
                                                <img src={approval} />
                                                <span class="typo-16 pri-typo-14">전자결재</span>
                                            </p>
                                            <p className="custom-radio-txt item-padding">
                                                <img src={vacation} />
                                                <span class="typo-16 pri-typo-14">휴가</span>
                                            </p>
                                            <p className="custom-radio-txt item-padding">
                                                <img src={conference} />
                                                <span class="typo-16 pri-typo-14">화상회의</span>
                                            </p>

                                            <p className="custom-radio-txt item-padding">
                                                <img src={todo} />
                                                <span class="typo-16 pri-typo-14">To Do</span>
                                            </p>

                                            {/* Show more*/}
                                            {show && (
                                                <div>
                                                    <p className="custom-radio-txt item-padding">
                                                        <img src={circular} />
                                                        <span class="typo-16 pri-typo-14">회람판</span>
                                                    </p>
                                                    <p className="custom-radio-txt item-padding">
                                                        <img src={board} />
                                                        <span class="typo-16 pri-typo-14">게시판</span>
                                                    </p>
                                                    <p className="custom-radio-txt item-padding">
                                                        <img src={resource} />
                                                        <span class="typo-16 pri-typo-14">공용설비</span>
                                                    </p>
                                                    <p className="custom-radio-txt item-padding">
                                                        <img src={expense} />
                                                        <span class="typo-16 pri-typo-14">비용보고</span>
                                                    </p>
                                                    <p className="custom-radio-txt item-padding">
                                                        <img src={workdiary} />
                                                        <span class="typo-16 pri-typo-14">노트</span>
                                                    </p>



                                                </div>
                                            )}


                                        </div>

                                    </div>
                                    <div >
                                        <button onClick={toggleDropdown} class="pri-typo-14 custom-more-btn">
                                            <span className="typo-16">더보기</span>
                                            {show ? (
                                                <ArrowDropUpIcon className="custom-more-ic" />
                                            ) : (
                                                <ArrowDropDownIcon className="custom-more-ic" />
                                            )}
                                        </button>


                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="pricing-container-card">
                            <div class="custom-card">
                                <div className={`custom-card-1 ${show ? 'active' : ''}`}>
                                    <div class="custom-title custom-padding">
                                        <span class="typo-21 typo-medium">메신저</span>
                                        <div class="custom-detail">
                                            <span class="typo-16">최소 5유저부터 시작</span>
                                        </div>
                                    </div>
                                    
                                    <div class="custom-pirce custom-padding">
                                        <span class="typo-32 ">1,000원 </span>
                                        <span class="typo-16">/ 월 유저당 1GB</span>
                                    </div>
                                    <a class="custom-button custom-padding" href="https://hanbiro.com/#/messenger-free-trial">
                                        <button class="typo-16">자세히 알아보기</button>
                                    </a>
                                    <div class="custom-radio">
                                        <div class="custom-radio-1">
                                            <p className="custom-radio-txt item-padding">
                                                <img src={talk} />
                                                <span class="typo-16 pri-typo-14">메신저</span>
                                            </p>
                                            <p className="custom-radio-txt item-padding">
                                                <img src={conference} />
                                                <span class="typo-16 pri-typo-14">화상회의</span>
                                            </p>

                                        </div>
                                        <div class="custom-radio-1">
                                            <p className="custom-radio-txt item-padding">
                                                <img src={whisper} />
                                                <span class="typo-16 pri-typo-14">쪽지</span>
                                            </p>

                                            <p className="custom-radio-txt item-padding">
                                                <img src={remote} />
                                                <span class="typo-16 pri-typo-14">원격지원</span>
                                            </p>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        
                    </div>

                    {/* <div className="pricing-al same-section">
                        <div className="pricing-al-sub"> 
                            <div class="price-services-row pricing-al-item content-padding">
                                <div class="basic-al-icon icon-padding">
                                    <svg className="al-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M325.8 152.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104l13.8 48.3zm-112.4 5.1c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94zm215.4 85.8l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z" /></svg>                            </div>
                                <div class="price-services-left">
                                    <div class="price-services-title typo-21">AI 전화</div>
                                    <div class=" typo-16 s-description">고객과의 통화 내용을 텍스트로 변환 / 저장된 통화내용을 요약 · 번역</div>
                                </div>
                                <div class="price-services-right">
                                    <div>
                                        <div class="price-services-item typo-16">
                                            <div > <span class="unit">유지당 / 월</span> </div>
                                            <div className="ai-unit"> <span class="services-price-i typo-21">1,000 원</span></div>
                                        </div>
                                        <div class="price-services-item typo-16">
                                            <div ><span class="unit">일회성 장비 구매</span></div>
                                            <div className="ai-unit"><span class="services-price-i typo-21">200,000 원</span></div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
               
                <div className="section-padding">
                    <div class="price-calculator-wrapper price-calculator-bg ">
                        <div class="price-calculator-title">
                            <span class="typo-32">가격 계산기</span>
                        </div>
                        <div className="price-calculate">
                            <div className="price-calculate-ed content-padding">
                                <div className="price-nt-ri">
                                    <span>※ 부가세 별도</span>
                                </div>
                                <div id="pricing_calculate">
                                    <div class="pricing_ct">
                                        <div class="pricing_modal">
                                            <div class="pricing_modal_ct">
                                                <div class="pricing_modal_box">
                                                    <div className="options">
                                                        {Object.entries(servicesData).map(([key, service]) => (
                                                            <button key={key} className={`pricing_tab ${key === currentService ? "active" : ""}`} onClick={() => setCurrentService(key)}>
                                                                {service.name}
                                                            </button>
                                                        ))}
                                                    </div>

                                                    <div>
                                                        <div class="mt-5">
                                                            <div class="modal-pro d-flex flex-column gap-3">
                                                                <div class="modal-info-item d-flex item-edit">
                                                                    <div class="modal-info-title">
                                                                        <span class="me-2">유저 수 </span>
                                                                    </div>
                                                                    <div class="modal-info-form">
                                                                        <div class="hanbiroGroupware option-show selectt">
                                                                            <form>
                                                                                <input class="imp-item-inp" type="number" value={userCount} onChange={(e) => setUserCount(parseInt(e.target.value) || 1)} />
                                                                            </form>
                                                                        </div>
                                                                        <div className="text-start mt-2 fw-bold">
                                                                            <div class="color-title-gw">
                                                                                *최소 사용자 수: <span>{serviceData.minUsers}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="modal-info-size">
                                                                        <span>명</span>
                                                                    </div>
                                                                </div>
                                                                <div class="modal-info-item d-flex">
                                                                    <div class="modal-info-title">
                                                                        <span>기본 용량</span>
                                                                    </div>
                                                                    <div class="modal-info-form">
                                                                        <div class="hanbiroGroupware option-show selectt">
                                                                            <form>
                                                                                <p type="text" id="dataDisplay" class="imp-item-inp">
                                                                                    {baseStorage}
                                                                                </p>
                                                                            </form>
                                                                        </div>
                                                                    </div>
                                                                    <div class="modal-info-size">
                                                                        <span>GB</span>
                                                                    </div>
                                                                </div>
                                                                <div class="modal-info-item d-flex">
                                                                    <div class="modal-info-title">
                                                                        <span>용량 추가 옵션</span>
                                                                    </div>
                                                                    <div class="modal-info-form">
                                                                        <select class="form-control imp-item-inp" value={selectedStorage} onChange={(e) => setSelectedStorage(e.target.value)}>
                                                                            <option value="">– 선택 –</option>
                                                                            <option value="50">50</option>
                                                                            <option value="500">500</option>
                                                                            <option value="1000">1</option>
                                                                        </select>
                                                                    </div>
                                                                    <div class="modal-info-size">
                                                                        <span id="unit-label">{selectedStorage === "1000" ? "TB" : "GB"}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="modal-info-item d-flex">
                                                                    <div class="modal-info-title">
                                                                        <span>결제 방식</span>
                                                                    </div>

                                                                    <div class="modal-info-radio text-start d-flex flex-column">
                                                                        <label class="mt-2">
                                                                            <input
                                                                                type="radio"
                                                                                name="paymentMethod"
                                                                                value="1"
                                                                                checked={paymentMethod === "1"}
                                                                                onChange={(e) => setPaymentMethod(e.target.value)}
                                                                            />
                                                                            &nbsp;월 납부
                                                                        </label>
                                                                        <label class="mt-2">
                                                                            <input
                                                                                type="radio"
                                                                                name="paymentMethod"
                                                                                value="6"
                                                                                checked={paymentMethod === "6"}
                                                                                onChange={(e) => setPaymentMethod(e.target.value)}
                                                                            />
                                                                            &nbsp;6개월 선납(10% 할인)
                                                                        </label>
                                                                        <label class="mt-2">
                                                                            <input
                                                                                type="radio"
                                                                                name="paymentMethod"
                                                                                value="12"
                                                                                checked={paymentMethod === "12"}
                                                                                onChange={(e) => setPaymentMethod(e.target.value)}
                                                                            />
                                                                            &nbsp;12개월 선납(15% 할인)
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="pricing_modal_box box-2-right">
                                                    <div class="price-box">
                                                        <div class="price_total_cal d-flex justify-content-between align-items-center box-title-right">
                                                            <div class="price-total-number me-5">
                                                                <span>월 요금</span>
                                                            </div>
                                                            <div class="price-total-number price-total-color">
                                                                <span id="final-total-fr">{numberWithCommas(finalTotal)}</span>
                                                                <span class="price-ko"> 원</span>
                                                            </div>
                                                        </div>

                                                        <div class="box2-bottom">
                                                            <div class="price-total-item pt-3 d-flex flex-column align-items-end ">
                                                                <div class="price_total_cal w-100 pb-2 d-flex justify-content-between align-items-center">
                                                                    <div class="price-total-txt me-5">
                                                                        <span>유저 수</span>
                                                                    </div>
                                                                    <div class="price-item-gb">
                                                                        <span id="gb-total">{userCount}</span>
                                                                        <span>명</span>
                                                                    </div>
                                                                </div>
                                                                <div class="price_total_cal w-100 pb-2 d-flex justify-content-between align-items-center">
                                                                    <div class="price-total-txt me-5">
                                                                        <span>총 용량</span>
                                                                    </div>
                                                                    <div class="price-item-gb">
                                                                        <span id="gb-total-all">{totalStorage}</span>
                                                                        <span>GB</span>
                                                                    </div>
                                                                </div>
                                                            </div>



                                                            <div class="price-total-item price-wrap mt-2">
                                                                <div class="price_total_cal d-flex justify-content-between align-items-center ">
                                                                    <div class="price-total-txt me-5">
                                                                        <span>• 기본 사용료</span>
                                                                    </div>
                                                                    <div class="price-item-gb">
                                                                        <span id="price-per">{numberWithCommas(serviceData.cost)}</span>
                                                                        <span> 원</span>
                                                                        &nbsp;x&nbsp;
                                                                        <span id="price-per-count">{userCount}</span>
                                                                        <span> 명</span>
                                                                        &nbsp;=&nbsp;
                                                                        <span id="price-per-count-total">{numberWithCommas(baseCost)}</span>
                                                                        <span> 원</span>
                                                                    </div>
                                                                </div>
                                                                <div id="price-additional">
                                                                    <div class="price_total_cal d-flex justify-content-between align-items-center">
                                                                        <div class="price-total-txt me-5">
                                                                            <span>• 용량 추가</span>
                                                                        </div>
                                                                        <div class="price-item-gb">
                                                                            <span id="gb-per">{gbPer}</span>
                                                                            <span id="unit-label-per">{unitLabelPer}</span>
                                                                            &nbsp;=&nbsp;
                                                                            <span id="gb-per-total">{numberWithCommas(cost)}</span>
                                                                            <span> 원</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="price-total pt-3 text-start">
                                                                <div class="price-total-txt price-total-note">
                                                                    <span>선납 할인</span>
                                                                </div>
                                                                <div class="price-total-note">
                                                                    <span></span>
                                                                </div>
                                                            </div>

                                                            <div class=" rounded p-3 box-4-right">
                                                                <div class="price-detail-item">
                                                                    <div class="price-box-total">
                                                                        <div class="price-detail-total fw-bold d-flex justify-content-between pb-2">
                                                                            <div>
                                                                                <span>기본 선납 금액</span>
                                                                            </div>
                                                                            <div>
                                                                                <span id="final-total">{numberWithCommas(paymentAmount)}</span>
                                                                                <span> 원</span>
                                                                            </div>
                                                                        </div>
                                                                        <div class="price-detail-total fw-bold d-flex justify-content-between">
                                                                            <div>
                                                                                <span>할인 금액 </span>
                                                                            </div>
                                                                            <div>
                                                                                <span id="discount-amount">-{numberWithCommas(discountPrice)}</span>
                                                                                <span> 원</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="price-total pt-3 d-flex justify-content-between">
                                                                    <div class="price-total-num price-total-num-final">
                                                                        <span id="sl-payment-method">최종 금액</span>
                                                                    </div>
                                                                    <div class="price-total-num">
                                                                        <span id="price_type">{paymentName}</span>
                                                                        <span id="need-to-pay">{numberWithCommas(needPay)}</span>
                                                                        <span class="price-ko"> 원</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="price-nt-left">
                                    <span>* 공용 SaaS형 기준이며, 단독형 / 구축형은 별도 문의 바랍니다.</span>
                                </div>
                                <div class="text-center mt-4">
                                    <a href="https://hanbiro.com/#/groupware-free-trial">
                                        <button class="price-button">데모신청</button>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="price-services-al same-section">
                        <div class="price-title title-section">
                            <span class="typo-32">부가 서비스</span>
                            <span class="typo-16"></span>
                        </div>
                        <div class="price-services">
                            <div class="price-services-ed content-padding">
                                <div class="price-services-row">
                                    <div class="price-services-left">
                                        <div class="price-services-title typo-21 typo-medium">AI 전화</div>
                                        <div class=" typo-16 s-description">고객과의 통화 내용을 텍스트로 변환 / 저장된 통화내용을 요약 · 번역</div>
                                    </div>
                                    <div class="price-services-right">
                                        <div>
                                            <div class="price-services-item typo-16">
                                                <span class="unit">유지당 / 월</span><span class="services-price-i typo-21">2,000 원</span>
                                            </div>
                                            <div class="price-services-item typo-16">
                                                <span class="unit">일회성 장비 구매</span><span class="services-price-i typo-21">200,000 원</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="price-services-row">
                                    <div class="price-services-left">
                                        <div class="price-services-title typo-21 typo-medium">용량추가</div>
                                        <div class=" typo-16 s-description">저장 공간이 부족할 경우, 업무 데이터 보관을 위해 용량을 확장할 수 있습니다.</div>
                                    </div>
                                    <div class="price-services-right">
                                        <div>
                                            <div class="price-services-item typo-16">
                                                <span class="unit">50GB/월 회사당</span><span class="services-price-i typo-21">10,000 원</span>
                                            </div>
                                            <div class="price-services-item typo-16">
                                                <span class="unit">500GB/월 회사당</span><span class="services-price-i typo-21">70,000 원</span>
                                            </div>
                                            <div class="price-services-item typo-16">
                                                <span class="unit">1TB/월 회사당</span><span class="services-price-i typo-21">100,000 원</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div class="price-services-row">
                                    <div class="price-services-left">
                                        <div class="price-services-title typo-21 typo-medium">승인메일</div>
                                        <div class=" typo-16 s-description">최종 승인 후에만 메일이 발송되도록 제한하는 보안 기능입니다.</div>
                                    </div>
                                    <div class="price-services-right">
                                        <div class="price-services-item typo-16"><span class="unit">공용서버</span><span class="services-price-i typo-21">20,000 원</span></div>
                                    </div>
                                </div>


                                <div class="price-services-row">
                                    <div class="price-services-left">
                                        <div class="price-services-title typo-21 typo-medium">외부백업</div>
                                        <div class=" typo-16 s-description">주요 데이터를 외부 서버에 별도로 백업하여 안정성을 강화합니다.</div>
                                    </div>
                                    <div class="price-services-right">
                                        <div class="price-services-item typo-16"><span class="unit">1TB 당</span><span class="services-price-i typo-21">40,000 원</span></div>
                                    </div>
                                </div>


                                <div class="price-services-row">
                                    <div class="price-services-left">
                                        <div class="price-services-title typo-21 typo-medium">근태 시스템 연동</div>
                                        <div class=" typo-16 s-description">세콤, 캡스 등 기존 출퇴근 관리 시스템과 연동하여 근태 데이터를 처리합니다.</div>
                                    </div>
                                    <div class="price-services-right">
                                        <div class="price-services-item typo-16"><span class="unit">일회성</span><span class="services-price-i typo-21">200,000 원</span></div>
                                    </div>
                                </div>


                                <div class="price-services-row">
                                    <div class="price-services-left">
                                        <div class="price-services-title typo-21 typo-medium">ERP 연동</div>
                                        <div class=" typo-16 s-description">전자결재, 통합로그인 (SSO), 조직도 연동 등 다양한 연동이 가능합니다.</div>
                                    </div>
                                    <div class="price-services-right">
                                    
                                    <div class="price-services-action">
                                        <div class="calculate-button">별도 커스터마징 협의</div>
                                    </div>
                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="basic-services section-padding">
                    <div class="price-title title-section">
                        <span class="typo-32">기본 제공 서비스</span>
                        <span class="typo-16 s-description"></span>
                    </div>
                    <div class="basic-services-wrapper">

                        <div class="basic-services-card content-padding">
                            <div class="basic-services-item">
                                <div class="basic-icon-circle icon-padding">
                                    <svg class="basic-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z" /></svg>
                                </div>
                                <div class="basic-services-content">
                                    <span class="typo-21 typo-medium">전자결재 양식 생성</span>
                                    <ul class="basic-li">
                                        <li><span class="typo-16">기본 양식 2~300 건 : 무료</span></li>
                                        <li> <span class="typo-16">제작 요청 20 건까지 : 무료</span></li>
                                    </ul>

                                </div>
                            </div>
                            <div class="basic-services-item-sm">
                                <div class="basic-icon-circle icon-padding">
                                    <svg class="basic-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 0a96 96 0 1 1 0 192A96 96 0 1 1 256 0zM228 279l-.2-.1c-.7-.5-2.4-1.5-5.2-2.9c-5.5-2.8-15.4-7.3-30.6-12.2c-28-9-74.2-19.3-144-22.7l0 176.3c84.9 5 147.1 22.3 184 35.7L232 282l-4-3zm52 3l0 171.1c36.9-13.4 99.1-30.7 184-35.7l0-176.3c-69.9 3.4-116 13.7-144 22.7c-15.1 4.9-25 9.4-30.6 12.2c-2.8 1.4-4.5 2.4-5.2 2.9l-.2 .1-4 3zM32 192.5C199.2 197.4 256 240 256 240s56.8-42.6 224-47.5c17.7-.5 32 13.9 32 31.5l0 208c0 17.7-14.4 31.9-32 32.7c-114.9 4.7-186.9 33.7-208.8 43.8c-4.8 2.2-9.9 3.5-15.1 3.5s-10.4-1.3-15.1-3.5c-21.9-10.1-93.9-39.1-208.8-43.8c-17.7-.7-32-15-32-32.7L0 224c0-17.7 14.4-32.1 32-31.5z" /></svg>
                                </div>
                                <div class="basic-services-content">
                                    <span class="typo-21 typo-medium">사용자 / 관리자 교육</span>
                                    <ul class="basic-li m0">
                                        <li><span class="typo-16">도입시 1 회 무상 지원</span></li>

                                    </ul>

                                </div>
                            </div>
                        </div>


                        <div class="basic-services-card content-padding">
                            <div class="basic-services-item">
                                <div class="basic-icon-circle icon-padding">
                                    <svg class="basic-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M48 160l0 256c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256-336 0 0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-5.6 0-11-1-16-2.7l0 50.7c0 8.8 7.2 16 16 16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-26.5 0-48-21.5-48-48l0-96 0-64-48 0zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM224 240c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-32zm80 80l96 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z" /></svg>
                                </div>
                                <div class="basic-services-content">
                                    <span class="typo-21 typo-medium">멀티도메인</span>
                                    <ul class="basic-li">
                                        <li><span class="typo-16">개수 제한 없이 무제한 추가</span></li>

                                    </ul>
                                </div>
                            </div>
                            <div class="basic-services-item-sm">
                                <div class="basic-icon-circle icon-padding">
                                    <svg class="basic-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M96 384a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM64 416c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-64 0zm256-32a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-64 0zm320-96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM448 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64zM544 48L96 48c-8.8 0-16 7.2-16 16l0 161.3c-18.3 3.1-34.8 11.3-48 23.1L32 64C32 28.7 60.7 0 96 0L544 0c35.3 0 64 28.7 64 64l0 184.4c-13.2-11.8-29.7-20.1-48-23.1L560 64c0-8.8-7.2-16-16-16z" /></svg>
                                </div>
                                <div class="basic-services-content">

                                    <span class="typo-21 typo-medium">회상회의</span>
                                    <ul class="basic-li m0">
                                        <li><span class="typo-16">시간 제한 없이 메신저 내 기능으로 제공</span></li>
                                    </ul>

                                </div>
                            </div>
                        </div>


                    </div>
                </div>

                <div class="faq-wrapper section-padding">
                    <div class="price-title title-section">
                        <span class="typo-32 typo-medium">자주하는 질문</span>
                        <span></span>
                    </div>
                    <div class="accordion accordion-cd" id="accordionExample">
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button typo-16 question"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne"
                                    aria-expanded="true"
                                    aria-controls="collapseOne"
                                >
                                    1. 다른 라이선스 상품을 함께 신청할 수 있나요?
                                </button>
                            </h2>
                            <div id="collapseOne" class="accordion-collapse typo-16 collapse show" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <span>

                                        가능합니다.<br></br>
                                        한비로는 그룹웨어, 메일, HR, 메신저, CloudDisk 총 5가지 라이선스 상품을 제공합니다. 이 중 그룹웨어는 모든 메뉴를 포함한 통합형 상품이며,<br></br>
                                        그룹웨어를 제외한 나머지 라이선스는 메일+메신저, HR+메일 등 원하는 조합으로 함께 신청하실 수 있습니다.<br></br>
                                        단, 라이선스는 상품 단위로만 구성 가능하며,<b> 개별 메뉴 단위 선택은 제한됩니다.</b>
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* <div class="divider-line"></div> */}
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button typo-16 question collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo"
                                    aria-expanded="false"
                                    aria-controls="collapseTwo"
                                >
                                    2. 할인 혜택이나 프로모션이 있나요?
                                </button>
                            </h2>
                            <div id="collapseTwo" class="accordion-collapse typo-16 collapse" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <span>
                                        <b>선납에 대한 상시 할인 혜택이</b> 있습니다. <br></br>
                                        공용 서버 기준으로 6개월 선납 시 10%, 12개월 선납 시 15%의 할인을 제공합니다.
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* <div class="divider-line"></div> */}
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button typo-16 question collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree"
                                    aria-expanded="false"
                                    aria-controls="collapseThree"
                                >
                                    3. 납부 기준이 어떻게 되나요?
                                </button>
                            </h2>
                            <div id="collapseThree" class="accordion-collapse typo-16 collapse" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <span>
                                        <b>요금은 사용자 1인당 기준으로 월 단위 과금됩니다.</b> <br></br>
                                        신규 사용자가 중간에 추가될 경우, <b>10일 기준으로 당월 또는 익월에 과금됩니다</b>.<br></br>
                                        * 한비로는 <b>사용자 수(유저 제한 수)를 기준으로 월 요금이</b> 산정되므로,
                                        사용자 수를 줄이려는 경우에는 고객센터로 문의해 주시기 바랍니다.
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* <div class="divider-line"></div> */}
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button typo-16 question collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseFor"
                                    aria-expanded="false"
                                    aria-controls="collapseFor"
                                >
                                    4. 그룹웨어 도입 시 초기 비용이 발생하나요?
                                </button>
                            </h2>
                            <div id="collapseFor" class="accordion-collapse typo-16 collapse" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <span>
                                        <b>별도의 초기 구축 비용은 없으며,  </b>
                                        사용자에 대한 라이선스 비용만 발생합니다.
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* <div class="divider-line"></div> */}
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button typo-16 question collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseFive"
                                    aria-expanded="false"
                                    aria-controls="collapseFive"
                                >
                                    5. 결제 방식에는 어떤 것이 있나요?
                                </button>
                            </h2>
                            <div id="collapseFive" class="accordion-collapse typo-16 collapse" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <span>
                                        카드 결제, 계좌이체, 자동이체 모두 가능합니다.
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* <div class="divider-line"></div> */}
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button typo-16 question collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseSix"
                                    aria-expanded="false"
                                    aria-controls="collapseSix"
                                >
                                    6. 해지 시 위약금이 발생하나요?
                                </button>
                            </h2>
                            <div id="collapseSix" class="accordion-collapse typo-16 collapse" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <span>
                                        아닙니다. 별도의 위약금은 발생하지 않습니다. <br></br>
                                        다만, <b>선납하신 경우에는 할인받은 금액을 차감한 후 환불이</b> 가능합니다.
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* <div class="divider-line"></div> */}
                    </div>
                </div>
                
            </div>

            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

export default Pricing;










